import { render } from "./ModalToolbar.vue?vue&type=template&id=2222123c&scoped=true"
import script from "./ModalToolbar.vue?vue&type=script&lang=js"
export * from "./ModalToolbar.vue?vue&type=script&lang=js"

import "./ModalToolbar.vue?vue&type=style&index=0&id=2222123c&lang=scss&scoped=true"

import exportComponent from "../../../../../DIARC/pixonanimation.az/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2222123c"]])

export default __exports__